import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", [_c("a-card", [_c("div", {
    staticClass: "infoBox"
  }, [_c("div", [_c("span", {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.infoObj.name))]), _vm.infoObj.orgTypeName ? _c("a-tag", {
    attrs: {
      color: "green"
    }
  }, [_vm._v(_vm._s(_vm.infoObj.orgTypeName))]) : _vm._e()], 1), _c("div", [_vm.infoObj.status == 1 ? _c("a-button", {
    staticClass: "marginR15",
    on: {
      click: function ($event) {
        return _vm.$router.push({
          name: "framework",
          params: {
            id: _vm.$route.params.id,
            customerId: _vm.$route.params.customerId
          }
        });
      }
    }
  }, [_c("svg-icon", {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      icon: "jiagou",
      size: 15
    }
  }), _vm._v(_vm._s(_vm.$t("架构图")))], 1) : _vm._e(), _vm.infoObj.status == 1 && _vm.$route.params.id != 0 ? _c("a-button", {
    attrs: {
      type: "danger"
    },
    on: {
      click: function ($event) {
        return _vm.handleDeactivate(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("停用")))]) : _vm._e(), _vm.infoObj.status == 0 && _vm.$route.params.id != 0 ? _c("a-button", {
    attrs: {
      type: "add"
    },
    on: {
      click: _vm.handleEnable
    }
  }, [_vm._v(_vm._s(_vm.$t("启用")))]) : _vm._e()], 1)]), _c("div", {
    staticClass: "infoBox2"
  }, [_c("div", [_vm._v(_vm._s(_vm.$t("负责人")) + "：" + _vm._s(_vm.infoObj.principal || "-"))]), _c("div", [_vm._v(_vm._s(_vm.$t("电话")) + "：" + _vm._s(_vm.infoObj.mobile || "-"))]), _c("div", [_vm._v(_vm._s(_vm.$t("员工数")) + "：" + _vm._s(_vm.pagination.total))])]), _vm.infoObj.status == 0 && _vm.$route.params.id != 0 ? _c("div", {
    staticClass: "infoBox2"
  }, [_c("div", [_vm._v(_vm._s(_vm.$t("停用时间")) + "：" + _vm._s(_vm.infoObj.updateAt || "-"))]), _c("div", [_vm._v(_vm._s(_vm.$t("操作人")) + "：" + _vm._s(_vm.infoObj.operator || "-"))])]) : _vm._e(), _vm.infoObj.status == 0 && _vm.$route.params.id != 0 ? _c("div", {
    staticClass: "infoBox2"
  }, [_c("div", [_vm._v(_vm._s(_vm.$t("停用原因")) + "：" + _vm._s(_vm.infoObj.reason || "-"))])]) : _vm._e()])], 1), _c("top-title", {
    staticClass: "marginT20"
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("所有员工")) + "(" + _vm._s(_vm.pagination.total) + ")")])]), _c("a-table", {
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      align: "center",
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function (text, record) {
        return [_c("a-switch", {
          attrs: {
            checked: text == 1 ? true : false
          },
          on: {
            click: function ($event) {
              return _vm.checkedFun(record);
            }
          }
        })];
      }
    }, {
      key: "isEdit",
      fn: function (text, record) {
        return [_c("a-switch", {
          attrs: {
            checked: text == 1 ? true : false
          },
          on: {
            click: function ($event) {
              return _vm.checkedFun2(record);
            }
          }
        })];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return _c("div", {}, [_vm.isAuth("home.companyPostEdit") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleAdd(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e(), _vm.isAuth("home.companyPostDelete") ? _c("a-button", {
          attrs: {
            type: "danger",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleDelete(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))]) : _vm._e()], 1);
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _vm.deactivateShow ? _c("deactivate-model", {
    ref: "deactivateForm",
    on: {
      cancel: function ($event) {
        _vm.deactivateShow = false;
      },
      ok: _vm.getInfoFun
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };